class MobileNavigation {
  constructor() {
    this.settings = {
      mainNav: '.mobile-nav',
    };
  }

  init() {
    const $nav = $(this.settings.mainNav);
    const $tab = $('#active-element');
    $tab.text($nav.find('.active').text());
    $nav.find('a').on({
      click() {
        $tab.text($(this).text());
        $nav.toggleClass('show');
        $('.mobile-tab').toggleClass('active');
      },
    });

    $('.mobile-tab').on({
      click(e) {
        e.preventDefault();
        $('.mobile-tab').toggleClass('active');
        $nav.toggleClass('show');
      },
    });
  }
}

export default MobileNavigation;
